import alert from '@/helpers/alert';

export function taskDocumentParams(route, type, record, context = null) {
  if (context) {
    if (context.completed || !context.id || context.type !== type
      || Number(context.placeId) !== Number(record?.id_place)
      || Number(context.patientId) !== Number(record?.id_patient)) return {};
    return { task_id: context.id, task_standalone: true };
  }
  const query = route.query;
  if (query.task_type !== type || !query.task_id
    || Number(query.task_place_id) !== Number(record?.id_place)
    || Number(route.params.patientId) !== Number(record?.id_patient)) {
    return {};
  }
  return { task_id: query.task_id };
}

export function taskDocumentLinked(params) {
  if (params.task_id && !params.task_standalone) {
    alert.toastSuccess('Documento vinculado à tarefa. Use “Ver tarefa e responder” para enviar a resposta.');
  }
}
